import React, { useContext } from 'react';
import { bool } from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import {
  BoxTruck,
  Box,
  CounterTop,
  DeliveryExpress,
  Drill,
  Floor,
  Key,
  LargeEquipment,
  Locker,
  Online,
  Propane,
  Refrigerator,
  Van
} from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';

export const StorePodServices = ({ disablePlaceholder, showIcon }) => {
  const { loading, store } = useContext(StorePodContext);
  const { services, flags, orderPickUpLocker } = store;
  const {
    applianceShowroom,
    expandedFlooringShowroom,
    keyCutting,
    kitchenShowroom,
    largeEquipment,
    loadNGo,
    penske,
    propane,
    toolRental,
    wiFi
  } = services || {};
  const { bopisFlag, bodfsFlag } = flags || {};

  const allServices = [
    { available: applianceShowroom, name: 'Expanded Appliance Showroom', icon: <Refrigerator /> },
    { available: bodfsFlag, name: 'Buy Online Deliver from Store', icon: <Van /> },
    { available: bopisFlag, name: 'Buy Online Pick Up in Store', icon: <Box /> },
    { available: expandedFlooringShowroom, name: 'Expanded Flooring Showroom', icon: <Floor /> },
    { available: keyCutting, name: 'Key Cutting', icon: <Key /> },
    { available: kitchenShowroom, name: 'Kitchen Showroom', icon: <CounterTop /> },
    { available: largeEquipment, name: 'Large Equipment Rental', icon: <LargeEquipment /> },
    { available: loadNGo, name: 'Home Depot Truck Rental', icon: <BoxTruck /> },
    { available: orderPickUpLocker, name: 'Order Pick Up Lockers', icon: <Locker /> },
    { available: penske, name: 'Moving Truck Rental', icon: <BoxTruck /> },
    { available: propane, name: 'Propane Exchange', icon: <Propane /> },
    { available: toolRental, name: 'Tool Rental', icon: <Drill /> },
    { available: wiFi, name: 'Free WiFi', icon: <Online /> }
  ];

  const availableServices = allServices.filter((service) => service.available);

  if (loading && !disablePlaceholder) {
    return (
      <div data-testid="store-pod-services__loader">
        <Placeholder height={showIcon ? '591.5px' : '260px'} type="rect" width="100%" />
      </div>
    );
  }

  if (availableServices.length === 0 || (loading && disablePlaceholder)) { return null; }

  return (
    <div>
      <ul>
        {
          availableServices.map((service, index) => (
            <li className={showIcon && 'sui-flex sui-align-center sui-p-2'} key={service.name}>
              {showIcon && (
                <span className="sui-mr-2">{service.icon}</span>
              )}
              <Typography height="tight">{service.name}</Typography>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

StorePodServices.propTypes = {
  disablePlaceholder: bool,
  showIcon: bool
};

StorePodServices.defaultProps = {
  disablePlaceholder: false,
  showIcon: false
};

StorePodServices.displayName = 'StorePodServices';
